import React from 'react';

import { BodyText } from '../../StyledComponents';
import ArrowIcon from '../../../../icons/arrow-down-24.svg';
import StyledButton from './StyledButton';

function LanguageButtonMobile(props) {
  return (
    <StyledButton
      color={props.color}
      hoverColor={props.hoverColor}
      onClick={props.onClick}
      data-active={props.active ? 1 : null}
    >
      <BodyText data-label fontSize="14">
        {props.children}
      </BodyText>
      <ArrowIcon data-icon aria-hidden="true" />
    </StyledButton>
  );
}

export default LanguageButtonMobile;
